import CTLUnReadCell from "application/components/CTLUnReadCell";
const operationURLS = {
  list: "/agentStatus/list",
  pdfDownload: "/agentStatus/generateAndDownloadPdf",
  csvDownload: "/agentStatus/downloadCSV",
  csvFilter: "agentStatus/downloadCSV1",
};

const getColumns = () => {
  return [
    {
      Header: "User Id",
      accessor: "username",
      displayInList: true,
      allowInForm: false,
      allowFilter: true,
      dataType: "string",
      filterControlType: "select",
      controlType: "multipleSelect",
      allowReportColumn: true,
      allowReportFilter: true,
      options: {
        keyField: "loginId",
        keyDescription: "username",
        values: [],
        url: "userInfoView/listAll",
      },
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "User Name",
      accessor: "userFullname",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
      filterControlType: "select",
    },
    {
      Header: "Extension No",
      accessor: "extensionNo",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Status",
      accessor: "status",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Log Date",
      accessor: "date",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "dateTime",
      allowReportColumn: true,
      customSortByName: "currentTime",
      allowReportFilter: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Log Time",
      accessor: "time",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "date",
      sortDisable: true,
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
  ];
};

export { getColumns, operationURLS };
